



























import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { SelectOptionData } from '../../../../../../../../../../../Pi/types'
import {
  systemLabelKey,
  SYSTEM_LABELS
} from '../../../../../../../Communications/Action/logic/Actions/LabelsAction/SYSTEM_LABELS'
import { ConditionsNodeProps } from '../../../../../logic/types'

@Component
export default class UserPropertiesCellLabels extends Vue {
  @Prop() labels!: ConditionsNodeProps['labels']

  @Prop() selectedId!: number

  @Emit()
  selectLabel(id :Array<string>): string {
    return id[0]
  }

  get selected() {
    return [ this.selectedId?.toString() ]
  }

  set selected(value: Array<string>) {
    this.selectLabel(value)
  }

  get labelsList(): Array<SelectOptionData> {
    const systemLabelsOptions: Array<SelectOptionData> = Object.entries(SYSTEM_LABELS)
      .filter(([ _, v ]) => v === SYSTEM_LABELS.BOT_USER_FLAG_CUSTOMER || v === SYSTEM_LABELS.BOT_USER_FLAG_POTENTIAL_CUSTOMER)
      .map(([ k, v ]) => ({ label: this.$t(systemLabelKey(k as keyof typeof SYSTEM_LABELS)).toString(), value: v }))

    systemLabelsOptions.push(...Object.entries(this.labels()).map(([ id, name ]) => {
      return {
        label: name,
        value: id,
      }
    }))

    return systemLabelsOptions
  }
}
